<template>
  <div class="d-flex flex-fill">
    <table class="table table-bordered">
      <thead>
        <tr>
          <th scope="col">
            <div class="d-flex flex-fill flex-column align-items-center justify-content-around">
              <button type="button" class="btn btn-primary">刪除</button>
              <b-form-checkbox name="selectAll-pro" value="accepted" unchecked-value="not_accepted">
                全選
              </b-form-checkbox>
            </div>
          </th>
          <th scope="col">
            <div class="d-flex flex-fill flex-column justify-content-around">
              <div>
                排序
              </div>
              <div>
                <a>重排</a>
              </div>
            </div>
          </th>
          <th scope="col">
            <div class="d-flex flex-fill flex-column justify-content-around">
              <div>商品代碼</div>
              <div>檢查重覆</div>
            </div>
          </th>
          <th scope="col">
            <div class="d-flex flex-fill align-items-center justify-content-around">
              <div>商品名稱</div>
              <div>
                <b-form-checkbox name="info-pro" value="accepted" unchecked-value="not_accepted">
                  簡要說明
                </b-form-checkbox>
              </div>
            </div>
          </th>
          <th scope="col">
            <div class="d-flex flex-fill flex-column justify-content-around">
              <div>
                一般價
              </div>
              <div>
                <a href="#">套用</a>
              </div>
            </div>
          </th>
          <th scope="col">
            <div class="d-flex flex-fill flex-column justify-content-around">
              <div>
                會員價
              </div>
              <div>
                <a>多個售價</a>
              </div>
            </div>
          </th>
          <th scope="col">
            <div class="d-flex flex-fill flex-column justify-content-around">
              <div>
                成本價
              </div>
              <div>
                <a>套用</a>
              </div>
            </div>
          </th>
          <th scope="col">
            <div class="d-flex flex-fill flex-column justify-content-around">
              <div>
                開放訂購
              </div>
              <div class="d-flex justify-content-center">
                <a href="#">全選</a>
                <a href="#">全消</a>
              </div>
            </div>
          </th>
          <th scope="col">
            <div class="d-flex flex-fill flex-column justify-content-around">
              <div>
                熱門商品
              </div>
              <div class="d-flex justify-content-center">
                <a href="#">全選</a>
                <a href="#">全消</a>
              </div>
            </div>
          </th>
          <th scope="col">
            <div class="d-flex flex-fill flex-column justify-content-around">
              <div>
                下架
              </div>
              <div class="d-flex justify-content-center">
                <a href="#">全選</a>
                <a href="#">全消</a>
              </div>
            </div>
          </th>
          <th scope="col">
            <div class="d-flex flex-fill flex-column justify-content-center">
              <div>
                編輯
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <b-form-checkbox name="select-pro" value="accepted" unchecked-value="not_accepted">
            </b-form-checkbox>
          </td>
          <td>1</td>
          <td>
            <b-form-input></b-form-input>
          </td>
          <td>
            <b-form-input></b-form-input>
          </td>
          <td>
            <b-form-input></b-form-input>
          </td>
          <td>
            <b-form-input></b-form-input>
          </td>
          <td>
            <b-form-input></b-form-input>
          </td>
          <td>
            <b-form-checkbox name="selectOpen-pro" value="accepted" unchecked-value="not_accepted">
            </b-form-checkbox>
          </td>
          <td>
            <b-form-checkbox name="selectHot-pro" value="accepted" unchecked-value="not_accepted">
            </b-form-checkbox>
          </td>
          <td>
            <b-form-checkbox name="selectOffsale-pro" value="accepted"
              unchecked-value="not_accepted">
            </b-form-checkbox>
          </td>
          <td><button type="button" class="btn btn-primary">編輯</button></td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- <div class="col-12 mx-auto d-flex flex-column">
    <div class="proEditTable d-flex flex-fill justify-content-between">
      <div class="d-flex flex-fill flex-column align-items-center justify-content-around">
        <button type="button" class="btn btn-primary">刪除</button>
        <b-form-checkbox name="selectAll-pro" value="accepted" unchecked-value="not_accepted">全選
        </b-form-checkbox>
      </div>
      <div class="d-flex flex-fill flex-column justify-content-around">
        <div>
          排序
        </div>
        <div>
          <a>重排</a>
        </div>
      </div>
      <div class="d-flex flex-fill flex-column justify-content-around">
        <div>商品代碼</div>
        <div>檢查重覆</div>
      </div>
      <div class="d-flex flex-fill align-items-center justify-content-around">
        <div>商品名稱</div>
        <div>
          <b-form-checkbox name="info-pro" value="accepted" unchecked-value="not_accepted">簡要說明
          </b-form-checkbox>
        </div>
      </div>
      <div class="d-flex flex-fill flex-column justify-content-around">
        <div>
          一般價
        </div>
        <div>
          <a href="#">套用</a>
        </div>
      </div>
      <div class="d-flex flex-fill flex-column justify-content-around">
        <div>
          會員價
        </div>
        <div>
          <a>多個售價</a>
        </div>
      </div>
      <div class="d-flex flex-fill flex-column justify-content-around">
        <div>
          成本價
        </div>
        <div>
          <a>套用</a>
        </div>
      </div>
      <div class="d-flex flex-fill flex-column justify-content-around">
        <div>
          開放訂購
        </div>
        <div>
          <a>全選 全消</a>
        </div>
      </div>
      <div class="d-flex flex-fill flex-column justify-content-around">
        <div>
          熱門商品
        </div>
        <div>
          <a>全選 全消</a>
        </div>
      </div>
      <div class="d-flex flex-fill flex-column justify-content-around">
        <div>
          下架
        </div>
        <div>
          <a>全選 全消</a>
        </div>
      </div>
      <div class="d-flex flex-fill flex-column justify-content-center">
        <div>
          編輯
        </div>
      </div>
    </div>
    <div class="proEditTable d-flex flex-fill justify-content-between">
      <div class="d-flex flex-fill align-items-center justify-content-center">
        <b-form-checkbox name="select-pro" value="accepted" unchecked-value="not_accepted">
        </b-form-checkbox>
      </div>
      <div class="d-flex flex-fill align-items-center justify-content-center">
        <div>1</div>
      </div>
      <div class="d-flex flex-fill align-items-center justify-content-center">
        <div>
          <b-form-input></b-form-input>
        </div>
      </div>
      <div class="d-flex flex-fill align-items-center justify-content-center">
        <div>
          <b-form-input></b-form-input>
        </div>
      </div>
      <div class="d-flex flex-fill align-items-center justify-content-center">
        <div>
          <b-form-input></b-form-input>
        </div>
      </div>
      <div class="d-flex flex-fill align-items-center justify-content-center">
        <div>
          <b-form-input></b-form-input>
        </div>
      </div>
      <div class="d-flex flex-fill align-items-center justify-content-center">
        <div>
          <b-form-input></b-form-input>
        </div>
      </div>
      <div class="d-flex flex-fill align-items-center justify-content-center">
        <b-form-checkbox name="selectOpen-pro" value="accepted" unchecked-value="not_accepted">
        </b-form-checkbox>
      </div>
      <div class="d-flex flex-fill align-items-center justify-content-center">
        <b-form-checkbox name="selectHot-pro" value="accepted" unchecked-value="not_accepted">
        </b-form-checkbox>
      </div>
      <div class="d-flex flex-fill align-items-center justify-content-center">
        <b-form-checkbox name="selectOffsale-pro" value="accepted" unchecked-value="not_accepted">
        </b-form-checkbox>
      </div>
      <div class="d-flex flex-fill align-items-center justify-content-center">
        <button type="button" class="btn btn-primary">編輯</button>
      </div>
    </div>
  </div> -->
</template>
<script>
export default {};

</script>
<style lang="scss"></style>
